<script setup>
import {computed} from 'vue'
import {useRouter} from 'vue-router'

import {usePageEditorStore} from '@/stores/pageEditor'

const props = defineProps({
    sectionId: Number
})

const router = useRouter()
const pageEditorStore = usePageEditorStore()

const activeSectionId = computed(() => pageEditorStore.activeSectionId)
const hoverSectionId = computed(() => pageEditorStore.hoverSectionId)
const sectionNumber = computed(() => pageEditorStore.pageSections.map(o => o.id).indexOf(props.sectionId) + 1)

const classNames = computed(() => {
    if (props.sectionId === activeSectionId.value) {
        return 'active'
    } else if (props.sectionId === hoverSectionId.value) {
        return 'list-group-item-hover'
    } else {
        return 'text-body-secondary bg-body-secondary'
    }
})

const onMouseover = () => {
    pageEditorStore.hoverSectionId = props.sectionId
}

const onMouseout = () => {
    pageEditorStore.hoverSectionId = 0
}

const onClick = async () => {
    await pageEditorStore.goToSection({
        router: router,
        sectionId: props.sectionId
    })

    await pageEditorStore.scrollToSection({sectionId: props.sectionId})
}
</script>

<template>
    <a role="button" class="list-group-item list-group-item-action py-1 strong text-uppercase small" :class="classNames"
       @mouseover="onMouseover" @mouseout="onMouseout" @click="onClick">
        <small class="flex-fill">Section {{ sectionNumber }}</small>
    </a>
</template>

<style scoped>
.list-group-item {
    border-color: transparent !important;
    font-size: 0.75rem;
    font-weight: 600;
}

.list-group-item-hover {
    z-index: 1;
    color: var(--bs-list-group-action-hover-color);
    text-decoration: none;
    background-color: rgba(9, 110, 253, 0.2);
}
</style>